module.exports = __webpack_public_path__ + "img/universe_print.149a6854.png";